import React from 'react';
import PageHoc from '../../HoC/PageHoC';
import Loader from 'react-loader-spinner';
import { getPublishStates } from '../../services/publishData';
import StateNode from './stateNode';
import { Row, Col } from 'react-bootstrap';

/**THis is a timer based container component
 * every 30 seconds it will grab from the API until its completed or failed
 */
class PublishedResultsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isError: false
        };
        // this.setState({ treeId: this.props.match.params });
    }
    async componentWillMount() {
        // this.isLoading
        this.isLoading(true);
        if (this.props.match.params.treeId) {
            await this.setState({ treeId: this.props.match.params.treeId });
            await this.getNodeStates();
        } else {
            //FAIL OR SOMETHING
        }
    }
    async componentDidMount() {
        const timer = setInterval(() => this.getNodeStates(), 30000);
        this.setState({ timerId: timer });
    }
    /**Every time it gets from the API it will cause it to update
     * so we handle removal of the timer here
     */
    componentDidUpdate() {
        if (this.state.orchestatorState !== undefined && this.state.timerId !== undefined) {
            const state = this.state.orchestatorState.state;
            if (state === "completed" || state === "failed") {
               this.removeTimer();
            }
            // if(this.state.orchestationState.state)
        }
    }
    componentWillUnmount(){
        if(this.state.timerId !== undefined){
            this.removeTimer();
        }
    }
    removeTimer = () =>{
        clearInterval(this.state.timerId);
        this.setState({ timerId: undefined });
    }
    /**Handles getting the states from the API */
    getNodeStates = async () => {
        this.isLoading(true);
        try {
            const nodeStates = await getPublishStates(this.state.treeId);
            this.setState({ orchestatorState: nodeStates.orchestationState, nodeState: nodeStates.nodeState });
        } catch (error) {
            this.setState({ isError: true });
        } finally {
            this.isLoading(false);
        }

    };
    isLoading = (boolean) => this.setState({ isLoading: boolean });
    /**Maps the nodes into rows of four */
    renderStateNodes = () => {
        const groupSize = 4;
        const { nodeState } = this.state;
        return nodeState.map((nodes) => {
            return <Col xs={3} key={"col" + nodes.id}> <StateNode name={nodes.nodeName}
                nodeType={nodes.nodeType} state={nodes.state}
                stateType={nodes.type} messages={nodes.messages} /></Col>;
        }).reduce((r, elem, index) => {
            console.log({ r });
            index % groupSize === 0 && r.push([]);
            r[r.length - 1].push(elem);
            return r;
        }, []).map((row, index) => {
            return <Row key={"nodestatesrow" + index}>{row}</Row>;
        });
    };
    render() {
        const { isError, isLoading, orchestatorState, nodeState } = this.state;
        console.log(orchestatorState);
        return <div className="container" style={{ top: "12vh", position: "relative" }}>
            <h2>Publish Results</h2>
            {isError ? <p>Error getting publish results, there maybe no publish results at this time</p> :
                isLoading ? <Loader /> : <div>
                    <StateNode name={"Orchestator"}
                        nodeType={"root"} state={orchestatorState.state}
                        stateType={orchestatorState.type} messages={orchestatorState.messages} />
                    {nodeState.length === 0 ? <p>There is currently no node state</p> : this.renderStateNodes()}
                </div>}
            {/* <p>{treeId}</p>
             */}
        </div>;
    }
}
export default PageHoc(PublishedResultsContainer);


// WEBPACK FOOTER //
// ./src/components/publishedResults/publishedResultsContainer.js